import { render, staticRenderFns } from "./DeviceInfoEnvolventeSobreaquec.vue?vue&type=template&id=605d4ffa&"
import script from "./DeviceInfoEnvolventeSobreaquec.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoEnvolventeSobreaquec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports